import axios from 'axios';
import {
    getAmountBorrowed,
    getCustomAmountBorrowed,
    getCustomRepaymentDuration,
    getRepaymentDuration,
} from '../../../selectors/namPersonalLoansCalculator/calculator';
import {
    calculateLoanResults,
    calculateLoanResultsFailure,
    calculateLoanResultsSuccess,
} from '../../../actions/namPersonalLoansCalculator/calculator';

export const calculationService = (store, next, action) => {
    const result = next(action);
    store.dispatch(calculateLoanResults());
    const state = store.getState();

    const amountBorrowed = getAmountBorrowed(state);
    const customAmountBorrowed = getCustomAmountBorrowed(state);
    const repaymentDuration = getRepaymentDuration(state);
    const customRepaymentDuration = getCustomRepaymentDuration(state);

    const loanAmount =
        amountBorrowed.value === 'custom' ? Number(customAmountBorrowed.value) : Number(amountBorrowed.value);
    const term =
        repaymentDuration.value === 'custom' ? Number(customRepaymentDuration.value) : Number(repaymentDuration.value);

    (async () => {
        const response = await calculateInstallment(loanAmount, term);
        if (response.status === 200) {
            store.dispatch(calculateLoanResultsSuccess(response.data));
        } else {
            store.dispatch(calculateLoanResultsFailure(response.data));
        }
    })();

    return result;
};

const calculateInstallment = async (loanAmount, term) => {
    try {
        const response = await axios.post(
            '/om-api/calculators/personal-loan-repayment-calculator',
            { loanAmount, term },
            { headers: { 'Content-Type': 'application/json' } }
        );
        return response;
    } catch (error) {
        return false;
    }
};
